import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ExternalLoginService, LoaderService, StorageService } from 'core-lib';
import { externalLoginProvider, IExternalLoginData} from 'core-lib';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-avoine-login-callback',
    imports: [TranslateModule, ButtonModule],
    templateUrl: './avoine-login-callback.component.html',
    styleUrl: './avoine-login-callback.component.scss'
})
export class AvoineLoginCallbackComponent {

  loginSuccessful: boolean = false;

  constructor(
    private loader: LoaderService,
    private storageService: StorageService,
    private router: Router,
    private externalLoginService: ExternalLoginService
  ) { }


  ngOnInit() {
    // Handle the callback logic here, e.g., extract tokens from URL, validate them, and log the user in


    //log all posted data to console
    // extract membership_number and email from query params
    const urlParams = new URLSearchParams(window.location.search);
    const membershipNumber = urlParams.get('membership_number');
    const email = urlParams.get('email');
    
    if (membershipNumber && email) {

      this.loader.setLoader('loader.loginSuccessful');
      
      let loginData:IExternalLoginData = {
        membershipNumber: membershipNumber,
        email: email,
        loginProvider: externalLoginProvider.SFC
      };

      this.externalLoginService.getExternalGuestProfile(loginData.loginProvider, loginData.membershipNumber, loginData.email).subscribe({
          next: (profileData) => {
            if (profileData.guestProfile) {
              loginData.guestProfile = profileData.guestProfile;
              this.loginSuccessful = true;
            }
            
          },
          error: (err) => {
            console.error('Error fetching profile data:', err);
          },
          complete: () => {
            this.storageService.saveSessionStorage('extLogin', btoa(JSON.stringify(loginData)));
            this.loader.hideLoader();
            this.router.navigate(['/availability']);
          }
      });


    } else {
      console.error('Missing membership number or email in callback');
      this.loginSuccessful = false;
    }

  }
}
